import { SidebarInset, SidebarProvider } from "@grafit/design-system/components/molecules/sidebar";
import { useLocalStorage } from "@grafit/design-system/hooks/use-local-storage";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { z } from "zod";
import { AppSidebar } from "../../components/layout/sidebar/app-sidebar";
import { useReportFeatureFlagsContext } from "../../utils/feature-flags";
import { MAIN_SCROLLABLE_AREA } from "../../utils/scroll-to-top";

export const Route = createFileRoute("/_auth/_frame")({
  component: FrameLayout,
});

function FrameLayout() {
  useReportFeatureFlagsContext();
  const [sidebarOpen, setSidebarOpen] = useLocalStorage("grafit-navigation-sidebar-open", true, z.boolean());

  return (
    <main className="flex h-screen flex-1">
      <div className="flex flex-1 flex-col overflow-hidden">
        <SidebarProvider className="h-full w-full" open={sidebarOpen} onOpenChange={setSidebarOpen}>
          <AppSidebar />
          <SidebarInset id={MAIN_SCROLLABLE_AREA} className="min-h-0">
            <Outlet />
          </SidebarInset>
        </SidebarProvider>
      </div>
    </main>
  );
}
